import React, { useState } from "react";
import classNames from "classnames";
import { SectionProps } from "../../utils/SectionProps";
import ButtonGroup from "../elements/ButtonGroup";
import Button from "../elements/Button";
import Image from "../elements/Image";
import Modal from "../elements/Modal";
import { InstagramEmbed } from "react-social-media-embed";
import logoBlack from "./../../assets/images/logo-black.svg";

const propTypes = {
  ...SectionProps.types,
};

const defaultProps = {
  ...SectionProps.defaults,
};

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  };

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  };

  const outerClasses = classNames(
    "hero section center-content",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "hero-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  return (
    <section {...props} className={outerClasses}>
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <div className="container-xs" style={{ marginBottom: 40 }}>
              <Image
                src={logoBlack}
                alt="Open"
                width={120}
                height={100}
              />
            </div>
            {/* <h1
              className='mt-0 mb-16 reveal-from-bottom'
              data-reveal-delay='200'
            >
              <span className='text-color-primary'>Keep Me Out</span> App
            </h1> */}

            {/* <div style={{ display: "flex", justifyContent: "center" }}>
              <InstagramEmbed
                url="https://www.instagram.com/p/C34t11RK4m-"
                width={620}
              />
            </div> */}

            <div className="container-xs" style={{ marginTop: 20}}>
              <p
                className="m-0 mb-32 reveal-from-bottom"
                data-reveal-delay="400"
              >
                With Keep Me Out we help users moderate their mobile usage by
                enabling them to lock their phone for a defined period of time.
              </p>
              <div className="reveal-from-bottom" data-reveal-delay="600">
                {/* <ButtonGroup style={{ marginBottom: 40 }}>
                  <Button
                    tag='a'
                    color='primary'
                    wideMobile
                    href='https://play.google.com/store/apps/details?id=vikesh.dass.keepmeout&hl=de&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
                  >
                    Download App
                  </Button>
                  <Button
                    tag='a'
                    color='dark'
                    wideMobile
                    href='https://play.google.com/store/apps/details?id=vikesh.dass.keepmeout&hl=de&gl=US'
                  >
                    View on Google Playstore
                  </Button>
                </ButtonGroup> */}
                <a href="https://play.google.com/store/apps/details?id=vikesh.dass.keepmeout">
                  <img
                    alt="Get it on Google Play"
                    style={{ maxWidth: 280 }}
                    src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                  />
                </a>
              </div>
            </div>
          </div>
          {/* <div
            className='hero-figure reveal-from-bottom illustration-element-01'
            data-reveal-value='20px'
            data-reveal-delay='800'
          >
            <a
              data-video='https://player.vimeo.com/video/174002812'
              href='#0'
              aria-controls='video-modal'
              onClick={openModal}
            >
              <Image
                className='has-shadow'
                src={require('./../../assets/images/video-placeholder.jpg')}
                alt='Hero'
                width={896}
                height={504}
              />
            </a>
          </div>
          <Modal
            id='video-modal'
            show={videoModalActive}
            handleClose={closeModal}
            video='https://player.vimeo.com/video/174002812'
            videoTag='iframe'
          /> */}
        </div>
      </div>
    </section>
  );
};

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;
